//@Version 1.0.3
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
   name: 'translateDesign',
   standalone: false
})
export class TranslateDesignPipe implements PipeTransform {
   private sTranslate = inject(TranslateService);

   transform(value: string): any { 
      if (value.indexOf('.') == -1) return value;
      let result: string | boolean | number | object | BigInt | undefined =  this.sTranslate.store.translations[ this.sTranslate.store.currentLang];
      let keyList: string[] = value.toString().split('.');

      if (result == undefined || result == null) return value;
      
      keyList.forEach((item: string) => {
         if (result![item as keyof typeof result] == undefined || result![item as keyof typeof result] == null) result = value;
         else result = result && (((typeof result[item as keyof typeof result] == 'string' )) || (typeof result[item as keyof typeof result] != 'string')) ? result[item as keyof typeof result] : value;
      })

      return result;
   }
}
